import { PayloadAction, createSlice } from '@reduxjs/toolkit';

type AdminState = {
  showIds: boolean;
  debugPanel: boolean;
};
export type AdminStateProps = AdminState;
const initialState: AdminState = {
  showIds: false,
  debugPanel: true,
};

export const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    setShowIds: (state: any, action: PayloadAction<boolean>) => {
      state.showIds = action.payload;
    },
    setDebugPanel: (state: any, action: PayloadAction<boolean>) => {
      state.debugPanel = action.payload;
    },
  },
});

export const adminActions = adminSlice.actions;
export const { setShowIds, setDebugPanel } = adminSlice.actions;

export default adminSlice.reducer;
